import map from "../../Images/client/brand/india-footprint.png";
import { Container, SectionHeading } from "./UI";
const metrics = [
  ["750+", "Farmers impacted"],
  ["400+", "Villages covered"],
  ["10+", "Rural jobs created"],
  ["12+", "States reached"],
];
export function ImpactMetric({ value, label }) {
  return (
    <div className="sn-border-t sn-border-line sn-py-6">
      <dt className="sn-text-sm sn-text-muted">{label}</dt>
      <dd className="sn-mt-3 sn-font-display sn-text-5xl sn-font-medium sn-tracking-tighter sn-text-forest lg:sn-text-6xl">
        {value}
      </dd>
    </div>
  );
}
export default function ImpactSection() {
  return (
    <section aria-labelledby="sn-impact-title" className="sn-py-16 md:sn-py-24">
      <Container className="sn-grid sn-gap-12 md:sn-grid-cols-2 md:sn-items-center lg:sn-gap-24">
        <div>
          <SectionHeading eyebrow="Our presence" id="sn-presence-title">
            Rooted in India.
            <br />
            Reaching further.
          </SectionHeading>
          <figure className="sn-mt-7">
            <img
              src={map}
              width="1536"
              height="1024"
              alt="Client-provided India footprint map highlighting Rajasthan, Madhya Pradesh, Telangana, Karnataka, Kerala, Arunachal Pradesh, Assam, Meghalaya, West Bengal, Odisha, Andhra Pradesh and Tamil Nadu"
              loading="lazy"
              className="sn-h-auto sn-w-full sn-max-w-xl sn-mix-blend-multiply"
            />
          </figure>
        </div>
        <div>
          <SectionHeading eyebrow="Our impact" id="sn-impact-title">
            Progress, measured
            <br />
            in people.
          </SectionHeading>
          <dl className="sn-mt-8 sn-grid sn-grid-cols-2 sn-gap-x-6">
            {metrics.map(([value, label]) => (
              <ImpactMetric key={label} value={value} label={label} />
            ))}
          </dl>
        </div>
      </Container>
    </section>
  );
}
